import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { QuizQuestionType } from 'src/app/quiz/models/quiz-question-type.enum';
import { QuizQuestion } from 'src/app/quiz/models/quiz-question.model';
import { QuizActions } from 'src/app/quiz/state/quiz.actions';

@Component({
  selector: 'app-view-quiz-answer',
  templateUrl: './view-quiz-answer.component.html',
  styleUrls: ['./view-quiz-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewQuizAnswerComponent implements OnInit {
  QuestionType = QuizQuestionType;

  @Input()
  question: QuizQuestion;

  @Input()
  questionNumber: number;

  @Input()
  answer: string[];

  @Input()
  summary: boolean;

  constructor(private store: Store) { }

  ngOnInit(): void {
    this.initAnswerConfig();
  }

  initAnswerConfig() {
    const { type } = this.question;

    // set picking mode
    const pickMode = type === QuizQuestionType.SelectAnatomy
      ? 'none'
      : 'single';
    this.store.dispatch(new QuizActions.SetQuizPickMode(pickMode));
  }

}
